/**
 * Table Name Helper Utilities
 * Provides functions for cleaning and formatting table names
 */

/**
 * Cleans a table name by removing:
 * - "temp_" prefix if present
 * - Trailing "_<timestamp>" pattern
 * 
 * @param {string} tableName - The original table name
 * @returns {string} - The cleaned table name
 * 
 * @example
 * cleanTableName("temp_newtable_411762963802490") // Returns "newtable"
 * cleanTableName("temp_mytable") // Returns "mytable"
 * cleanTableName("regular_table") // Returns "regular_table"
 */
export const cleanTableName = (tableName) => {
  if (!tableName || typeof tableName !== "string") {
    return tableName;
  }
  
  let cleanName = tableName;
  
  // Remove "temp_" prefix if present
  if (cleanName.startsWith("temp_")) {
    cleanName = cleanName.substring(5);
  }
  
  // Remove trailing "_<timestamp>" pattern (e.g., "_411762963802490")
  cleanName = cleanName.replace(/_\d+$/, "");
  
  return cleanName;
};

